import Logo from './logo-sympla.svg';

function LogoSympla() {
  return <Logo />;
}
export default LogoSympla;
